import Cookies from "js-cookie";
export const combinationsList = [
  {
    permission: "viewInvoicesPermission",
    currentRoute: "/account/billing/invoice",
    callback: "billingAndPayments",
    allowNonERP: false,
  },
  {
    permission: "managePaymentsPermission",
    currentRoute: "/account/billing/invoice",
    callback: "billingAndPayments",
    allowNonERP: false,
  },
  {
    permission: "viewallotherCasesPermission",
    currentRoute: "/support/cases/caseList",
    callback: "supportCases",
    allowNonERP: true,
  },
  {
    permission: "viewFinancialCasesPermission",
    currentRoute: "/support/cases/caseList",
    callback: "supportCases",
    allowNonERP: true,
  },
  {
    permission: "viewallotherCasesPermission",
    currentRoute: "/support/cases/viewCaseDetails",
    callback: Cookies.get("currentRoute"),
    allowNonERP: true,
  },
  {
    permission: "viewFinancialCasesPermission",
    currentRoute: "/support/cases/viewCaseDetails",
    callback: Cookies.get("currentRoute"),
    allowNonERP: true,
  },
  {
    permission: "manageyourcontractandservicesPermission",
    currentRoute: "/account/myContract",
    callback: "myContract",
    allowNonERP: false,
  },
  {
    permission: "viewtechnicianAppointmentsPermission",
    currentRoute: "/account/technicianAppointments",
    callback: "/account/technicianAppointments",
    allowNonERP: false,
  },
  {
    permission: "viewtechnicianAppointmentsPermission",
    currentRoute: "/account/technicianAppointments/transferDevice",
    callback: "/account/technicianAppointments/transferDevice",
    allowNonERP: false,
  },
  {
    permission: "viewtechnicianAppointmentsPermission",
    currentRoute: "/account/technicianAppointments/removeDevice",
    callback: "/account/technicianAppointments/removeDevice",
    allowNonERP: false,
  },
  {
    permission: "viewtechnicianAppointmentsPermission",
    currentRoute: "/account/technicianAppointments/viewAppointmentDetails",
    callback: "/account/technicianAppointments/viewAppointmentDetails",
    allowNonERP: false,
  },
  {
    permission: "viewtechnicianAppointmentsPermission",
    currentRoute: "/account/technicianAppointments/reschedule",
    callback: "/account/technicianAppointments/reschedule",
    allowNonERP: false,
  },
  {
    permission: "accountProfilePermission",
    currentRoute: "/account/myProfile/primaryAccount",
    callback: "accountProfile",
    allowNonERP: true,
  },
];

export const getDefaultLandingPermission = (fullAndReadOnlyPermissions, isNonERPCountryAccount) => {
  if (Object.keys(fullAndReadOnlyPermissions).length === 0) return false;
  let matchedPermission = combinationsList.find((item) => {
    if (
      (Cookies.get("currentRoute") === item.currentRoute || Cookies.get("currentRoute").includes(item.currentRoute)) &&
      Object.keys(fullAndReadOnlyPermissions).includes(item.permission)
    ) {
      if (isNonERPCountryAccount) {
        return item.allowNonERP;
      } else {
        return true;
      }
    }
  });
  if (matchedPermission && Object.keys(matchedPermission).length) {
    return matchedPermission.callback;
  }
  matchedPermission = combinationsList.find((item) => {
    if (Object.keys(fullAndReadOnlyPermissions).includes(item.permission)) {
      if (isNonERPCountryAccount) {
        return item.allowNonERP;
      } else {
        return true;
      }
    }
  });
  if (matchedPermission && Object.keys(matchedPermission).length) {
    return matchedPermission.callback;
  } else {
    return false;
  }
};
